import React, { useState } from 'react';
import bgimage from '../../assets/images/bgimage.jpg'
import { Link } from 'react-router-dom';
import LoginHook from '../../hooks/LoginHook'
export default function Login() {

    const { agencyLogin, isLoading } = LoginHook()
    const [rememberMe, setRememberMe] = useState('')
    const [contact, setContact] = useState('')
    const [password, setPassword] = useState('')

    const submitForm = async (e) => {
        e.preventDefault()
        await agencyLogin(contact, password, rememberMe)
    }
    return (
        <div className='container-fluid bg-white signup_form '>

            <div className="row px-0 ">
                <div className="col-md-6 col-lg-4 d-lg-block d-none p-0">
                    <div className="bg_image">
                        <img src={bgimage} className='p-0' alt="" />
                        
                    </div>

                </div>
                <div className="col-md-10 col-lg-4 px-md-1 px-xl-4 px-2 my-auto mx-auto p-0">
                    <form onSubmit={submitForm}>
                        <div className="mb-1">
                            <h1>Login to your Account</h1>
                            <p>Welcome back!</p>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                {/* <label htmlFor="">Email address</label> */}
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
                                </svg>
                                <input
                                    type="email" className='m-0'
                                    placeholder='Email'
                                    required
                                    value={contact}
                                    onChange={(e) => setContact(e.target.value)}
                                />
                            </div>
                            <div className="col-md-12">
                                <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M22.5 11V8.2C22.5 7.0799 22.5 6.51984 22.282 6.09202C22.0903 5.71569 21.7843 5.40973 21.408 5.21799C20.9802 5 20.4201 5 19.3 5H5.7C4.5799 5 4.01984 5 3.59202 5.21799C3.21569 5.40973 2.90973 5.71569 2.71799 6.09202C2.5 6.51984 2.5 7.0799 2.5 8.2V11.8C2.5 12.9201 2.5 13.4802 2.71799 13.908C2.90973 14.2843 3.21569 14.5903 3.59202 14.782C4.01984 15 4.5799 15 5.7 15H11.5M12.5 10H12.505M17.5 10H17.505M7.5 10H7.505M19.75 17V15.25C19.75 14.2835 18.9665 13.5 18 13.5C17.0335 13.5 16.25 14.2835 16.25 15.25V17M12.75 10C12.75 10.1381 12.6381 10.25 12.5 10.25C12.3619 10.25 12.25 10.1381 12.25 10C12.25 9.86193 12.3619 9.75 12.5 9.75C12.6381 9.75 12.75 9.86193 12.75 10ZM17.75 10C17.75 10.1381 17.6381 10.25 17.5 10.25C17.3619 10.25 17.25 10.1381 17.25 10C17.25 9.86193 17.3619 9.75 17.5 9.75C17.6381 9.75 17.75 9.86193 17.75 10ZM7.75 10C7.75 10.1381 7.63807 10.25 7.5 10.25C7.36193 10.25 7.25 10.1381 7.25 10C7.25 9.86193 7.36193 9.75 7.5 9.75C7.63807 9.75 7.75 9.86193 7.75 10ZM16.1 21H19.9C20.4601 21 20.7401 21 20.954 20.891C21.1422 20.7951 21.2951 20.6422 21.391 20.454C21.5 20.2401 21.5 19.9601 21.5 19.4V18.6C21.5 18.0399 21.5 17.7599 21.391 17.546C21.2951 17.3578 21.1422 17.2049 20.954 17.109C20.7401 17 20.4601 17 19.9 17H16.1C15.5399 17 15.2599 17 15.046 17.109C14.8578 17.2049 14.7049 17.3578 14.609 17.546C14.5 17.7599 14.5 18.0399 14.5 18.6V19.4C14.5 19.9601 14.5 20.2401 14.609 20.454C14.7049 20.6422 14.8578 20.7951 15.046 20.891C15.2599 21 15.5399 21 16.1 21Z" stroke="#9197B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <input
                                    type="password" className='m-0'
                                    placeholder='Password'
                                    required
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                            <div className="col-md-12 mt-2">
                                <div className="d-flex justify-content-between px-1">
                                    <div className="left">
                                        <label htmlFor="remember_me " className='remember_me'>
                                            <input
                                                type="checkbox"
                                                className="me-2 d-inline"
                                                checked={rememberMe}
                                                onChange={(e) => setRememberMe(e.target.checked)}
                                            />
                                            Remember me
                                        </label>
                                    </div>
                                    <div className="right">
                                        <p className='text-center text-sm'><Link to='/forgot_password'>Forgot Password?</Link></p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <button type="submit" className="btn submit_btn w-100 mt-4" disabled={isLoading}>Login</button>
                            <p className='mt-3 text-center'>Not a member? <Link to='/signup'>Register Now!</Link></p>
                        </div>
                    </form>
                </div>
            </div>

        </div>
    );
}
